// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bch_a bia_a bia_q bia_j bia_wl bia_bj","ImgResponsive__img":"bch_b bia_b bia_ql"};